import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {
    APP_ANDROID,
    APP_IOS,
    PROGRESS_SIM_ACTIVATE,
    PROGRESS_SIM_ACTIVATED,
    SIM_ESIM,
    STATUS_COMPLETE,
    STATUS_ERROR,
    STATUS_PENDING
} from "./../../constants";
import AjaxLoaderImg from "../../components/AjaxLoaderImg";
import DataSource from "../../DataSource";
import globals from "../../globals";
import {connect} from "react-redux";
import {getCustomer} from "../../redux/actions";

const ProgressTrackerRowsMobile = ({ data, serviceDetails, getCustomer }) => {

    const [qrCode, setQrCode] = useState(null)
    const [qrError, setQrError] = useState(false)
    const [activationStatus, setActivationStatus] = useState(null) //pending|complete|error|validate

    useEffect(() => {
        const isReadyForActivation = data.filter(item => item.type === PROGRESS_SIM_ACTIVATE && item.completed)
        if (serviceDetails.simType === SIM_ESIM && isReadyForActivation.length > 0) {
            getQrCode()
        }
    }, [serviceDetails.simType]);

    const handleActivateService = () => {
        setActivationStatus(STATUS_PENDING);
        getCustomer()
        const handleSuccess = () => {
            setActivationStatus(STATUS_COMPLETE)
            globals.pushEvent('ActivateSim')
        }
        const handleError = () => {
            setActivationStatus(STATUS_ERROR)
        }

        if (serviceDetails.type === 'sim') {
            DataSource.postActivateNewSim({hspaService: parseInt(serviceDetails.serviceId)}, handleSuccess, handleError)
        } else {
            DataSource.postActivateMobileService({serviceId: parseInt(serviceDetails.serviceId)}, handleSuccess, handleError)
        }
    }

    const getQrCode = () => {
        setQrError(false)
        DataSource.getSimQrCode(serviceDetails.serviceId, response => {
            if (response.data && response.data.qr_icon) {
                setQrCode(response.data.qr_icon)
            }
        }, error => {
            console.error(error)
            setQrError(true)
        })
    }

    const RowActiveTextOnly = ({ item }) => {
        return (
            <div className="d-flex">
                <div className="icon-col">
                    <img src="/images/icon-progress-active.svg" alt="Active" />
                    <div className="line" />
                </div>
                <div className="main-col">
                    <p className="m-0 mb-2 mb-md-3 bold color-blue">{item.title}</p>
                    <p className="m-0 mb-3 d-md-none color-blue">{item.date}</p>
                    <div className="d-flex align-items-md-center">
                        {item.hasError ? <IconWarning /> : ''}
                        <p className='m-0' style={{whiteSpace: 'pre-wrap'}}>{item.description}</p>
                    </div>
                </div>
                <div className="date-col color-blue">
                    {item.date}
                </div>
            </div>
        )
    }

    const RowInactiveTextOnly = ({ item }) => {
        return (
            <div className="d-flex">
                <div className="icon-col">
                    <img src="/images/progress-icon-inactive.svg" alt="Inactive" />
                </div>
                <div className="main-col d-flex align-items-center">
                    <p className="m-0 bold color-grey-200">{item.title}</p>
                </div>
                <div className="date-col" />
            </div>
        )
    }

    const RowActivate = ({ item }) => {
        return (
            <div className="d-flex">
                <div className="icon-col">
                    <img src={`/images/${item.completed && serviceDetails.isActivated ? 'icon-progress-active.svg' : 'progress-icon-activate.svg'}`} alt="Activate" />
                    <div className="line" />
                </div>
                <div className="main-col">
                    <p className="m-0 mb-3 bold color-blue">{item.title}</p>
                    <div className="d-flex align-items-start">
                        {activationStatus !== STATUS_ERROR && item.completed && !serviceDetails.isActivated && <img src="/images/progress-icon-bell.svg" alt="Bell" className="d-inline-block mr-2" />}
                        <div>
                            {ActivateNow(item)}
                        </div>
                    </div>
                </div>
                <div className="date-col color-blue">
                    {item.date}
                </div>
            </div>
        )
    }

    const RowActivated = ({ item }) => {
        return (
            <div className="d-flex">
                <div className="icon-col">
                    <img src="/images/icon-progress-activated.svg" alt="Activated" />
                </div>
                <div className="main-col">
                    <p className="m-0 mb-3 bold color-green-500">{item.title}</p>
                    <p className="m-0 mb-3">
                        <span className="bold">Woohoo!</span> Your mobile SIM has been successfully activated. If you are porting your existing phone number, wait for your previous signal to stop, then insert your new SIM into your device.
                    </p>
                    <p className="m-0 mb-3">You can also track and manage your account using our Exetel App for your phone. </p>
                    <div className="d-flex app-store">
                        <a href={APP_IOS} target="_blank" rel="noreferrer">
                            <img src="/images/appStore.svg" alt="Exetel App on Apple App Store" className="mb-2 mb-lg-0 mr-lg-5" />
                        </a>
                        <a href={APP_ANDROID} target="_blank" rel="noreferrer">
                            <img src="/images/googlePlay.svg" alt="Exetel App on Google Play" className="block" />
                        </a>
                    </div>
                </div>
                <div className="date-col color-blue">
                    {item.date}
                </div>
            </div>
        )
    }

    const ActivateNow = item => {
        const scanQrCode = <React.Fragment>
            <p className="m-0 mb-1">Now, scan the QR code with your mobile phone to download the eSIM. This may take a few minutes to appear.</p>
            <p className='mb-3'>Please refresh the page to view</p>
            <div>
                {qrCode ? <img src={qrCode} alt="[QR Code]" width="150px" /> : ''}
                {qrError ? <p className="m-0">An error occurred while trying to download your eSIM. Please try again shortly.</p> : ''}
            </div>
        </React.Fragment>

        if (item.completed && serviceDetails.isActivated) {
            if (serviceDetails.simType === SIM_ESIM && qrCode) {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-md-center mb-3">
                            <p className="m-0">Process completed. If you are transferring your number, wait for your previous signal to stop, then scan the QR code to install your eSIM.</p>
                        </div>
                        {scanQrCode}
                    </React.Fragment>
                )
            } else {
                return (
                    <p className="m-0">Process completed.</p>
                )
            }
        } else if (activationStatus === STATUS_PENDING) {
            return (
                <div className="d-flex align-items-md-center">
                    <AjaxLoaderImg width='20px' className="mr-2" />
                    <p className="m-0">Activation process started...</p>
                </div>
            )
        } else if (activationStatus === STATUS_COMPLETE) {
            return (
                <React.Fragment>
                    <div className="d-flex align-items-md-center mb-3">
                        <img src="/images/icon-progress-tick.svg" alt="Success" className="mr-2" />
                        <p className='m-0'>{`Process completed. ${serviceDetails.simType === SIM_ESIM ? 'If you are transferring your number, wait for your previous signal to stop, then scan the QR code to install your eSIM.' : ''}`}</p>
                    </div>
                    {serviceDetails.simType === SIM_ESIM && scanQrCode}
                </React.Fragment>
            )
        } else if (activationStatus === STATUS_ERROR) {
            return (
                <React.Fragment>
                    <div className="d-flex align-items-md-center mb-3">
                        <IconWarning />
                        <p className='m-0'>There’s a problem with porting your phone number.</p>
                    </div>
                    <div className="d-flex align-items-md-center mb-3">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="mr-2">
                            <path d="M19.1764 7.99132H19.0011C18.8146 7.98802 18.6288 8.01446 18.45 8.07002C18.45 5.53521 15.2642 3 11.7568 3C8.24928 3 5.54834 6.5493 5.54834 8.07042C5.37277 8.01533 5.18992 7.98874 5.00662 7.99125H4.82514C4.34284 7.98779 3.8789 8.18406 3.53641 8.53662C3.19375 8.88918 3.00074 9.3689 3 9.86974V13.9903C3 15.0403 3.81827 15.9145 4.82514 15.9145H5.00647C6.00639 15.9145 6.8207 15.0403 6.8207 13.9903V9.9236C6.8207 6.97183 9.14405 4.5703 12 4.5703C14.856 4.5703 17.1793 6.97183 17.1793 9.9236V13.761C17.181 15.6036 16.2658 17.3165 14.7592 18.2907C14.2069 18.6499 13.5946 18.8987 12.954 19.0242C12.7471 18.7361 12.4297 18.5559 12.0845 18.5303C11.7395 18.5044 11.4006 18.6359 11.1562 18.8902C10.9118 19.1446 10.7859 19.4967 10.8116 19.8549C10.837 20.2131 11.0114 20.5422 11.2893 20.7563C11.5671 20.9705 11.9209 21.0485 12.2588 20.9703C12.5966 20.8922 12.8848 20.6653 13.0486 20.3489C14.0094 20.1849 14.9219 19.7975 15.7179 19.2155C16.5139 18.6335 17.1728 17.8722 17.6451 16.9884C17.8655 16.579 18.0431 16.1464 18.1748 15.6978C18.43 15.8369 18.7132 15.9111 19.0013 15.9142H19.1765C20.1816 15.9142 21 15.0455 21 14.0022V9.86335C20.9985 9.36363 20.8053 8.88516 20.463 8.53368C20.1208 8.18238 19.6577 7.98741 19.1764 7.99132ZM5.54736 13.9902C5.54736 14.3113 5.30447 14.5922 5.00684 14.5922H4.82535C4.52591 14.5922 4.27377 14.3058 4.27377 13.9902V9.86961C4.27422 9.7193 4.3329 9.5756 4.43676 9.47093C4.54061 9.36611 4.68071 9.30929 4.82536 9.31322H5.00684C5.14997 9.31102 5.28809 9.36878 5.38983 9.47345C5.49156 9.57812 5.54826 9.72103 5.54736 9.86961V13.9902ZM19.7264 14.0023C19.7264 14.3166 19.4793 14.5923 19.1765 14.5923H19.0012C18.6984 14.5923 18.4528 14.3167 18.4528 14.0023V9.86348C18.4528 9.54916 18.6984 9.31324 19.0012 9.31324H19.1765C19.4793 9.31324 19.7264 9.54917 19.7264 9.86348V14.0023Z" fill="#4200B3"/>
                        </svg>
                        <p className='m-0'>Please contact our support team</p>
                    </div>
                    <a href="tel:1800578737" className="btn-secondary-light-small">Call 13 39 38</a>
                </React.Fragment>
            )
        } else {
            if (serviceDetails.simType === SIM_ESIM) {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-md-center mb-3">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="mr-2">
                                <path d="M19.1764 7.99132H19.0011C18.8146 7.98802 18.6288 8.01446 18.45 8.07002C18.45 5.53521 15.2642 3 11.7568 3C8.24928 3 5.54834 6.5493 5.54834 8.07042C5.37277 8.01533 5.18992 7.98874 5.00662 7.99125H4.82514C4.34284 7.98779 3.8789 8.18406 3.53641 8.53662C3.19375 8.88918 3.00074 9.3689 3 9.86974V13.9903C3 15.0403 3.81827 15.9145 4.82514 15.9145H5.00647C6.00639 15.9145 6.8207 15.0403 6.8207 13.9903V9.9236C6.8207 6.97183 9.14405 4.5703 12 4.5703C14.856 4.5703 17.1793 6.97183 17.1793 9.9236V13.761C17.181 15.6036 16.2658 17.3165 14.7592 18.2907C14.2069 18.6499 13.5946 18.8987 12.954 19.0242C12.7471 18.7361 12.4297 18.5559 12.0845 18.5303C11.7395 18.5044 11.4006 18.6359 11.1562 18.8902C10.9118 19.1446 10.7859 19.4967 10.8116 19.8549C10.837 20.2131 11.0114 20.5422 11.2893 20.7563C11.5671 20.9705 11.9209 21.0485 12.2588 20.9703C12.5966 20.8922 12.8848 20.6653 13.0486 20.3489C14.0094 20.1849 14.9219 19.7975 15.7179 19.2155C16.5139 18.6335 17.1728 17.8722 17.6451 16.9884C17.8655 16.579 18.0431 16.1464 18.1748 15.6978C18.43 15.8369 18.7132 15.9111 19.0013 15.9142H19.1765C20.1816 15.9142 21 15.0455 21 14.0022V9.86335C20.9985 9.36363 20.8053 8.88516 20.463 8.53368C20.1208 8.18238 19.6577 7.98741 19.1764 7.99132ZM5.54736 13.9902C5.54736 14.3113 5.30447 14.5922 5.00684 14.5922H4.82535C4.52591 14.5922 4.27377 14.3058 4.27377 13.9902V9.86961C4.27422 9.7193 4.3329 9.5756 4.43676 9.47093C4.54061 9.36611 4.68071 9.30929 4.82536 9.31322H5.00684C5.14997 9.31102 5.28809 9.36878 5.38983 9.47345C5.49156 9.57812 5.54826 9.72103 5.54736 9.86961V13.9902ZM19.7264 14.0023C19.7264 14.3166 19.4793 14.5923 19.1765 14.5923H19.0012C18.6984 14.5923 18.4528 14.3167 18.4528 14.0023V9.86348C18.4528 9.54916 18.6984 9.31324 19.0012 9.31324H19.1765C19.4793 9.31324 19.7264 9.54917 19.7264 9.86348V14.0023Z" fill="#4200B3"/>
                            </svg>
                            <p className="m-0">Your new mobile eSIM is ready to be activated. Please make sure you are connected to Wi-Fi before proceeding.</p>
                        </div>
                        <button className="btn-secondary-light-small mb-4" onClick={handleActivateService}>Activate now</button>
                    </React.Fragment>
                )
            } else {
                return (
                    <div>
                        <p className="m-0 mb-3">Once you have received your new SIM, click on the button below to start the activation process.</p>
                        <button className="btn-secondary-light-small" onClick={handleActivateService}>Activate now</button>
                    </div>
                )
            }
        }
    }

    return (
        <div className="progress-tracker-rows">
            {data.map((item, key) => {
                if (item.type === PROGRESS_SIM_ACTIVATE && item.completed) {
                    return <RowActivate key={key} item={item} />
                } else if (item.type === PROGRESS_SIM_ACTIVATED && item.completed) {
                    return <RowActivated key={key} item={item} />
                } else if (item.completed) {
                    return <RowActiveTextOnly key={key} item={item} />
                } else {
                    return <RowInactiveTextOnly key={key} item={item} />
                }
            })}
        </div>
    )

}

const IconWarning = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="mr-2">
            <path fillRule="evenodd" clipRule="evenodd" d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.2 13.6V7.2H12.8V13.6H11.2ZM11.2 15.2H12.8V16.8H11.2V15.2Z" fill="#D3354A"/>
        </svg>
    )
}

ProgressTrackerRowsMobile.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        date: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        description: PropTypes.string,
        stepTitle: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        completed: PropTypes.bool.isRequired,
    })).isRequired,
    serviceDetails: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    validIdCheck: state.auth.validIdCheck
})

export default connect(mapStateToProps, { getCustomer })(ProgressTrackerRowsMobile)



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnection/ProgressTrackerRowsMobile.js